export default __webpack_public_path__ + "static/media/46.5495cdcd.jpg";